var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99995 4.99995V3.13344C4.99995 2.38671 4.99995 2.01307 5.14528 1.72786C5.27311 1.47698 5.47693 1.27315 5.72781 1.14532C6.01302 1 6.38666 1 7.13339 1H10.8667C11.6134 1 11.9866 1 12.2718 1.14532C12.5227 1.27315 12.7268 1.47698 12.8547 1.72786C13 2.01307 13 2.38643 13 3.13316V6.86647C13 7.6132 13 7.98656 12.8547 8.27177C12.7268 8.52265 12.5225 8.72689 12.2716 8.85472C11.9867 8.99991 11.6139 8.99991 10.8686 8.99991H8.99991M4.99995 4.99995H3.13344C2.38671 4.99995 2.01307 4.99995 1.72786 5.14528C1.47698 5.27311 1.27315 5.47693 1.14532 5.72781C1 6.01302 1 6.38666 1 7.13339V10.8667C1 11.6134 1 11.9866 1.14532 12.2718C1.27315 12.5227 1.47698 12.7268 1.72786 12.8547C2.01279 12.9999 2.38598 12.9999 3.13125 12.9999H6.86896C7.61423 12.9999 7.9869 12.9999 8.27183 12.8547C8.52272 12.7268 8.72689 12.5225 8.85472 12.2716C8.99991 11.9867 8.99991 11.6139 8.99991 10.8686V8.99991M4.99995 4.99995H6.86673C7.61346 4.99995 7.98662 4.99995 8.27184 5.14528C8.52272 5.27311 8.72689 5.47693 8.85472 5.72781C8.99991 6.01274 8.99991 6.38594 8.99991 7.13122L8.99991 8.99991",
    stroke: "#7069FD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.18ef09ed1b2993a97d8235e7e7e1ea8d.svg";
export { ForwardRef as ReactComponent };